import React from 'react'

type AddIconProps = {
  size?: number
}

export const AddIcon = ({ size = 14 }: AddIconProps) => (
  <svg
    fill='none'
    height={size}
    viewBox='0 0 14 14'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <line
      stroke='currentColor'
      strokeLinecap='round'
      strokeWidth='1.5'
      x1='7'
      x2='7'
      y1='1'
      y2='13'
    />
    <line
      stroke='currentColor'
      strokeLinecap='round'
      strokeWidth='1.5'
      x1='1'
      x2='13'
      y1='7'
      y2='7'
    />
  </svg>
)
